import apiClient from "./client";
import type { GetTenantsParams, TenantsListResponse } from "../types/tenant";

export const getTenants = async (
  params: GetTenantsParams
): Promise<TenantsListResponse> => {
  const { data } = await apiClient.get<TenantsListResponse>("/tenants", {
    params: {
      code: params.code || "",
      name: params.name || "",
      page: params.page,
      limit: params.limit,
    },
  });
  return data;
};
